/**
 * ◀ [date – date] ▶ + reset cluster for paging/zooming a time-series chart's
 * visible window. Pairs with useTimeWindow — the chart wires the handlers and
 * passes a preformatted range label (each chart formats its own dates).
 */
export function WindowNav({
  canBack,
  canFwd,
  onBack,
  onFwd,
  label,
  isWindowed,
  onReset,
  resetLabel,
}: {
  canBack: boolean;
  canFwd: boolean;
  onBack: () => void;
  onFwd: () => void;
  label: string;
  isWindowed: boolean;
  onReset: () => void;
  resetLabel: string;
}) {
  return (
    <div className="flex items-center gap-1 text-[11px] text-terminal-ink-muted">
      <button
        type="button"
        onClick={onBack}
        disabled={!canBack}
        title="Earlier"
        className="rounded border border-white/10 bg-terminal-panel px-1.5 py-0.5 font-semibold transition-colors enabled:hover:text-terminal-ink disabled:opacity-30"
      >
        ◀
      </button>
      <span className="min-w-[118px] text-center tabular-nums">{label}</span>
      <button
        type="button"
        onClick={onFwd}
        disabled={!canFwd}
        title="Later"
        className="rounded border border-white/10 bg-terminal-panel px-1.5 py-0.5 font-semibold transition-colors enabled:hover:text-terminal-ink disabled:opacity-30"
      >
        ▶
      </button>
      {isWindowed && (
        <button
          type="button"
          onClick={onReset}
          className="ml-1 rounded border border-white/10 bg-terminal-panel px-2 py-0.5 font-semibold text-terminal-ink-muted transition-colors hover:text-terminal-ink"
        >
          {resetLabel}
        </button>
      )}
    </div>
  );
}
